module.exports = __webpack_public_path__ + "static/media/GongXiang2.96e21980.png";